import React from "react";
import { SnackbarProvider } from "notistack";

import CustomSnackbar from "./custom-snackbar";

const NotistackProvider = ({ children }) => {
  const hideDuration = 3000;

  return (
    <SnackbarProvider
      autoHideDuration={hideDuration}
      hideIconVariant
      Components={{
        default: CustomSnackbar,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotistackProvider;
